/**
 * Monaco completions for FaaS `cb` / `logger` (JS, Python, Ruby, Go, Rust, Java, C#).
 * Expressive5 and Agentic are not given a dialect — no SDK IntelliSense there.
 *
 * The TS/JS language worker is stubbed (webpack 4), so extra .d.ts never runs.
 * This provider does the job on the main thread. Vue 2 / webpack 4 safe — no optional chaining.
 */

var SDK_LANGUAGES = ["javascript", "typescript", "python", "ruby", "go", "rust", "java", "csharp"]

var CB_CAMEL = [
  { label: "endpoint", detail: "API origin for this run", insertText: "endpoint", property: true },
  { label: "caseId", detail: "Current case id (script run context)", insertText: "caseId", property: true },
  { label: "graphql", detail: "Run a GraphQL query", insertText: "graphql(${1:query}, ${2:{}})" },
  { label: "getCase", detail: "Load the current case, or pass a case id", insertText: "getCase(${1})" },
  { label: "createCase", detail: "Create a case", insertText: "createCase({ caseTypeCode: ${1:code}, properties: ${2:{}} })" },
  { label: "createCaseSimple", detail: "Create a case from properties", insertText: "createCaseSimple(${1:caseTypeCode}, ${2:{}})" },
  { label: "updateCase", detail: "Update a case (id defaults to current)", insertText: "updateCase({ properties: ${1:{}} })" },
  { label: "deleteCase", detail: "Delete a case", insertText: "deleteCase(${1:id})" },
  { label: "search", detail: "Search cases of a type", insertText: "search(${1:caseTypeCode}, ${2:query})" },
  { label: "findCase", detail: "First matching case", insertText: "findCase(${1:caseTypeCode}, ${2:query})" },
  { label: "caseTypeSearch", detail: "Search within a case type", insertText: "caseTypeSearch(${1:term}, ${2:caseTypeId})" },
  { label: "executeCaseTask", detail: "Run a case task", insertText: "executeCaseTask(${1:caseTaskId})" },
  { label: "createTimelineEvent", detail: "Timeline event on the current case; set caseId in options for another case", insertText: "createTimelineEvent(${1:message}, { ${2} })" },
  { label: "getRelated", detail: "Related cases from the current case; set caseId in options for another case", insertText: "getRelated(${1:caseTemplateCode}, { ${2} })" }
]

var CB_SNAKE = [
  { label: "endpoint", detail: "API origin for this run", insertText: "endpoint", property: true },
  { label: "case_id", detail: "Current case id (script run context)", insertText: "case_id", property: true },
  { label: "graphql", detail: "Run a GraphQL query", insertText: "graphql(${1:query}, ${2:{}})" },
  { label: "get_case", detail: "Load the current case, or pass a case id", insertText: "get_case(${1})" },
  { label: "create_case", detail: "Create a case", insertText: "create_case({ \"caseTypeCode\": ${1:code}, \"properties\": ${2:{}} })" },
  { label: "create_case_simple", detail: "Create a case from properties", insertText: "create_case_simple(${1:case_type_code}, ${2:{}})" },
  { label: "update_case", detail: "Update a case (id defaults to current)", insertText: "update_case({ \"properties\": ${1:{}} })" },
  { label: "delete_case", detail: "Delete a case", insertText: "delete_case(${1:id})" },
  { label: "search", detail: "Search cases of a type", insertText: "search(${1:case_type_code}, ${2:query})" },
  { label: "find_case", detail: "First matching case", insertText: "find_case(${1:case_type_code}, ${2:query})" },
  { label: "case_type_search", detail: "Search within a case type", insertText: "case_type_search(${1:term}, ${2:case_type_id})" },
  { label: "execute_case_task", detail: "Run a case task", insertText: "execute_case_task(${1:case_task_id})" },
  { label: "create_timeline_event", detail: "Timeline event on the current case; set case_id in options for another case", insertText: "create_timeline_event(${1:message}, { ${2} })" },
  { label: "get_related", detail: "Related cases from the current case; set case_id in options for another case", insertText: "get_related(${1:case_template_code}, { ${2} })" },
  { label: "getCase", detail: "Alias of get_case", insertText: "getCase(${1})" },
  { label: "createCase", detail: "Alias of create_case", insertText: "createCase({ \"caseTypeCode\": ${1:code}, \"properties\": ${2:{}} })" },
  { label: "createCaseSimple", detail: "Alias of create_case_simple", insertText: "createCaseSimple(${1:case_type_code}, ${2:{}})" },
  { label: "updateCase", detail: "Alias of update_case", insertText: "updateCase({ \"properties\": ${1:{}} })" },
  { label: "deleteCase", detail: "Alias of delete_case", insertText: "deleteCase(${1:id})" },
  { label: "findCase", detail: "Alias of find_case", insertText: "findCase(${1:case_type_code}, ${2:query})" },
  { label: "caseTypeSearch", detail: "Alias of case_type_search", insertText: "caseTypeSearch(${1:term}, ${2:case_type_id})" },
  { label: "executeCaseTask", detail: "Alias of execute_case_task", insertText: "executeCaseTask(${1:case_task_id})" },
  { label: "createTimelineEvent", detail: "Alias of create_timeline_event", insertText: "createTimelineEvent(${1:message}, { ${2} })" },
  { label: "getRelated", detail: "Alias of get_related", insertText: "getRelated(${1:case_template_code}, { ${2} })" }
]

var CB_RUST = [
  { label: "endpoint", detail: "API origin for this run", insertText: "endpoint", property: true },
  { label: "case_id", detail: "Current case id (script run context)", insertText: "case_id", property: true },
  { label: "graphql", detail: "Run a GraphQL query", insertText: "graphql(${1:query}, json!(${2:{}}))" },
  { label: "get_case", detail: "Load the current case, or pass a case id", insertText: "get_case(${1:None})" },
  { label: "create_case", detail: "Create a case", insertText: "create_case(json!({ \"caseTypeCode\": ${1:code}, \"properties\": ${2:{}} }))" },
  { label: "create_case_simple", detail: "Create a case from properties", insertText: "create_case_simple(${1:case_type_code}, json!(${2:{}}))" },
  { label: "update_case", detail: "Update a case (id defaults to current)", insertText: "update_case(json!({ \"properties\": ${1:{}} }))" },
  { label: "delete_case", detail: "Delete a case", insertText: "delete_case(${1:id})" },
  { label: "search", detail: "Search cases of a type", insertText: "search(${1:case_type_code}, ${2:query}, None, None, None)" },
  { label: "find_case", detail: "First matching case", insertText: "find_case(${1:case_type_code}, ${2:query})" },
  { label: "case_type_search", detail: "Search within a case type", insertText: "case_type_search(${1:term}, ${2:case_type_id}, None, None)" },
  { label: "execute_case_task", detail: "Run a case task", insertText: "execute_case_task(${1:case_task_id})" },
  { label: "create_timeline_event", detail: "Timeline event on the current case; set case_id in options for another case", insertText: "create_timeline_event(${1:message}, Some(json!({ ${2} })))" },
  { label: "get_related", detail: "Related cases from the current case; set case_id in options for another case", insertText: "get_related(${1:case_template_code}, Some(json!({ ${2} })))" }
]

var CB_CSHARP = [
  { label: "Endpoint", detail: "API origin for this run", insertText: "Endpoint", property: true },
  { label: "CaseId", detail: "Current case id (script run context)", insertText: "CaseId", property: true },
  { label: "Graphql", detail: "Run a GraphQL query", insertText: "Graphql(${1:query}, ${2:null})" },
  { label: "GetCase", detail: "Load the current case, or pass a case id", insertText: "GetCase(${1})" },
  { label: "CreateCase", detail: "Create a case", insertText: "CreateCase(new { caseTypeCode = ${1:code}, properties = ${2:new {}} })" },
  { label: "CreateCaseSimple", detail: "Create a case from properties", insertText: "CreateCaseSimple(${1:caseTypeCode}, ${2:new {}})" },
  { label: "UpdateCase", detail: "Update a case (id defaults to current)", insertText: "UpdateCase(new { properties = ${1:new {}} })" },
  { label: "DeleteCase", detail: "Delete a case", insertText: "DeleteCase(${1:id})" },
  { label: "Search", detail: "Search cases of a type", insertText: "Search(${1:caseTypeCode}, ${2:query})" },
  { label: "FindCase", detail: "First matching case", insertText: "FindCase(${1:caseTypeCode}, ${2:query})" },
  { label: "CaseTypeSearch", detail: "Search within a case type", insertText: "CaseTypeSearch(${1:term}, ${2:caseTypeId})" },
  { label: "ExecuteCaseTask", detail: "Run a case task", insertText: "ExecuteCaseTask(${1:caseTaskId})" },
  { label: "CreateTimelineEvent", detail: "Timeline event on the current case; set caseId in options for another case", insertText: "CreateTimelineEvent(${1:message}, new Dictionary<string, object?> { ${2} })" },
  { label: "GetRelated", detail: "Related cases from the current case; set caseId in options for another case", insertText: "GetRelated(${1:caseTemplateCode}, new Dictionary<string, object?> { ${2} })" }
]

var CB_GO = [
  { label: "Endpoint", detail: "API origin for this run", insertText: "Endpoint", property: true },
  { label: "CaseId", detail: "Current case id (script run context)", insertText: "CaseId", property: true },
  { label: "Graphql", detail: "Run a GraphQL query", insertText: "Graphql(${1:query}, ${2:nil})" },
  { label: "GetCase", detail: "Load the current case, or pass a case id", insertText: "GetCase(${1})" },
  { label: "CreateCase", detail: "Create a case", insertText: "CreateCase(map[string]any{ \"caseTypeCode\": ${1:code}, \"properties\": ${2:map[string]any{}} })" },
  { label: "CreateCaseSimple", detail: "Create a case from properties", insertText: "CreateCaseSimple(${1:caseTypeCode}, ${2:map[string]any{}})" },
  { label: "UpdateCase", detail: "Update a case (id defaults to current)", insertText: "UpdateCase(map[string]any{ \"properties\": ${2:map[string]any{}} })" },
  { label: "DeleteCase", detail: "Delete a case", insertText: "DeleteCase(${1:id})" },
  { label: "Search", detail: "Search cases of a type", insertText: "Search(${1:caseTypeCode}, ${2:query}, ${3:1}, ${4:25}, []string{\"title\"})" },
  { label: "FindCase", detail: "First matching case", insertText: "FindCase(${1:caseTypeCode}, ${2:query})" },
  { label: "CaseTypeSearch", detail: "Search within a case type", insertText: "CaseTypeSearch(${1:term}, ${2:caseTypeId}, ${3:0}, ${4:25})" },
  { label: "ExecuteCaseTask", detail: "Run a case task", insertText: "ExecuteCaseTask(${1:caseTaskId})" },
  { label: "CreateTimelineEvent", detail: "Timeline event on the current case; set caseId in options for another case", insertText: "CreateTimelineEvent(${1:message}, map[string]any{ ${2} })" },
  { label: "GetRelated", detail: "Related cases from the current case; set caseId in options for another case", insertText: "GetRelated(${1:caseTemplateCode}, map[string]any{ ${2} })" }
]

var LOGGER_LOWER = [
  { label: "debug", detail: "Debug log", insertText: "debug(${1:message})" },
  { label: "info", detail: "Info log", insertText: "info(${1:message})" },
  { label: "warn", detail: "Warning log", insertText: "warn(${1:message})" },
  { label: "error", detail: "Error log", insertText: "error(${1:message})" }
]

var LOGGER_GO = [
  { label: "Debug", detail: "Debug log", insertText: "Debug(${1:message})" },
  { label: "Info", detail: "Info log", insertText: "Info(${1:message})" },
  { label: "Warn", detail: "Warning log", insertText: "Warn(${1:message})" },
  { label: "Error", detail: "Error log", insertText: "Error(${1:message})" }
]

var GLOBALS_COMMON = [
  { label: "cb", detail: "Authenticated GraphQL SDK", insertText: "cb" },
  { label: "logger", detail: "Script log (appears in the Log panel)", insertText: "logger" },
  { label: "payload", detail: "Flat case document", insertText: "payload" },
  { label: "options", detail: "Run context (current_user, params, …)", insertText: "options" },
  { label: "document", detail: "Same document as payload", insertText: "document" }
]

var TIMELINE_OPTS = [
  { camel: "caseId", snake: "case_id", primary: true, detail: "Target another case (omit to use the current case)" },
  { camel: "title", snake: "title", detail: "Event title (defaults to the case title)" },
  { camel: "success", snake: "success", detail: "false also notifies the acting user" },
  { camel: "causedAt", snake: "caused_at", detail: "When it happened (ISO datetime)" },
  { camel: "metadata", snake: "metadata", detail: "JSON metadata" },
  { camel: "logs", snake: "logs", detail: "JSON logs" },
  { camel: "output", snake: "output", detail: "JSON output" },
  { camel: "scriptName", snake: "script_name", detail: "Script name shown on the event" }
]

var RELATED_OPTS = [
  { camel: "caseId", snake: "case_id", primary: true, detail: "Target another case (omit to use the current case)" },
  { camel: "fromCaseId", snake: "from_case_id", primary: true, detail: "Same as caseId — source case for the relation" },
  { camel: "relatedKey", snake: "related_key", detail: "Which relationship when more than one exists" },
  { camel: "page", snake: "page", detail: "Page (default 0)" },
  { camel: "pageSize", snake: "page_size", detail: "Page size (default 100)" },
  { camel: "sortField", snake: "sort_field", detail: "Sort field" },
  { camel: "sortDirection", snake: "sort_direction", detail: "Sort direction" }
]

var UPDATE_OPTS = [
  { camel: "id", snake: "id", primary: true, detail: "Target another case (omit to use the current case)" },
  { camel: "title", snake: "title", detail: "Case title" },
  { camel: "currentState", snake: "current_state", detail: "State name" },
  { camel: "properties", snake: "properties", detail: "Case properties object" },
  { camel: "checkVersion", snake: "check_version", detail: "Reject the save on a version conflict" },
  { camel: "force", snake: "force", detail: "Bypass version check" }
]

var CREATE_OPTS = [
  { camel: "caseTypeCode", snake: "case_type_code", primary: true, detail: "Template code for the new case" },
  { camel: "title", snake: "title", detail: "Case title" },
  { camel: "currentState", snake: "current_state", detail: "Initial state name" },
  { camel: "properties", snake: "properties", detail: "Case properties object" }
]

var modelDialects = {}
var providerRegistered = false

function normalizeDialect(value) {
  var raw = String(value || "").toLowerCase()
  if (raw === "js" || raw === "javascript" || raw === "typescript") return "javascript"
  if (raw === "py" || raw === "python" || raw === "python3") return "python"
  if (raw === "rb" || raw === "ruby") return "ruby"
  if (raw === "go" || raw === "golang") return "go"
  if (raw === "rs" || raw === "rust") return "rust"
  if (raw === "java") return "java"
  if (raw === "cs" || raw === "csharp" || raw === "dotnet" || raw === "c#") return "csharp"
  return null
}

export function resolveScriptSdkDialect(preset, runtimeLanguage) {
  var p = String(preset || "").toLowerCase()
  if (p === "expressive5" || p === "exp5" || p === "agentic" || p === "agent") return null
  var fromPreset = normalizeDialect(p)
  if (fromPreset) return fromPreset
  if (p === "custom") {
    return normalizeDialect(runtimeLanguage) || "javascript"
  }
  return normalizeDialect(runtimeLanguage)
}

function cbMembersForDialect(dialect) {
  if (dialect === "go") return CB_GO
  if (dialect === "csharp") return CB_CSHARP
  if (dialect === "rust") return CB_RUST
  if (dialect === "python" || dialect === "ruby") return CB_SNAKE
  return CB_CAMEL
}

function loggerMembersForDialect(dialect) {
  if (dialect === "go" || dialect === "csharp") return LOGGER_GO
  return LOGGER_LOWER
}

function globalsForDialect(dialect) {
  var list = GLOBALS_COMMON.slice()
  if (dialect === "python") {
    list.push({ label: "result", detail: "Output document (defaults to payload)", insertText: "result" })
  }
  return list
}

function optionsGroupForMethod(name) {
  var n = String(name || "").toLowerCase()
  if (n === "createtimelineevent" || n === "create_timeline_event") return "timeline"
  if (n === "getrelated" || n === "get_related") return "related"
  if (n === "updatecase" || n === "update_case") return "update"
  if (n === "createcase" || n === "create_case") return "create"
  return null
}

function optionDefsForGroup(group) {
  if (group === "timeline") return TIMELINE_OPTS
  if (group === "related") return RELATED_OPTS
  if (group === "update") return UPDATE_OPTS
  if (group === "create") return CREATE_OPTS
  return []
}

function prefersSnakeKeys(dialect) {
  return dialect === "python" || dialect === "ruby" || dialect === "rust"
}

function optionKeyEntries(group, dialect) {
  var defs = optionDefsForGroup(group)
  var snakeFirst = prefersSnakeKeys(dialect)
  var out = []
  var i
  for (i = 0; i < defs.length; i++) {
    var def = defs[i]
    var primaryName = snakeFirst ? def.snake : def.camel
    var aliasName = snakeFirst ? def.camel : def.snake
    out.push({
      label: primaryName,
      detail: def.detail,
      primary: !!def.primary,
      alias: false
    })
    if (aliasName && aliasName !== primaryName) {
      out.push({
        label: aliasName,
        detail: def.detail + " (alias)",
        primary: false,
        alias: true
      })
    }
  }
  return out
}

function optionInsertText(dialect, name, quoted) {
  if (dialect === "python") {
    return quoted ? name + "\": ${1}" : "\"" + name + "\": ${1}"
  }
  if (dialect === "ruby") {
    return name + ": ${1}"
  }
  if (dialect === "go" || dialect === "rust") {
    return quoted ? name + "\": ${1}" : "\"" + name + "\": ${1}"
  }
  if (dialect === "csharp") {
    return quoted ? name + "\"] = ${1}" : "[\"" + name + "\"] = ${1}"
  }
  return name + ": ${1}"
}

function charIsQuote(ch) {
  return ch === "\"" || ch === "'" || ch === "`"
}

function findOpenCbCall(text) {
  var re = /\bcb\s*\.\s*([A-Za-z0-9_]+)\s*\(/g
  var matches = []
  var found
  while ((found = re.exec(text)) !== null) {
    matches.push({ name: found[1], argsStart: found.index + found[0].length })
  }
  var i
  for (i = matches.length - 1; i >= 0; i--) {
    var args = text.substring(matches[i].argsStart)
    var depth = 1
    var inStr = false
    var strCh = ""
    var j
    var closed = false
    for (j = 0; j < args.length; j++) {
      var ch = args.charAt(j)
      var prev = j > 0 ? args.charAt(j - 1) : ""
      if (inStr) {
        if (ch === strCh && prev !== "\\") inStr = false
        continue
      }
      if (charIsQuote(ch)) {
        inStr = true
        strCh = ch
        continue
      }
      if (ch === "(") depth++
      if (ch === ")") {
        depth--
        if (depth === 0) {
          closed = true
          break
        }
      }
    }
    if (!closed && depth > 0) {
      return { name: matches[i].name, args: args }
    }
  }
  return null
}

function inferCbOptionsScope(text) {
  var call = findOpenCbCall(text)
  if (!call) return null
  var group = optionsGroupForMethod(call.name)
  if (!group) return null
  var args = call.args
  var braceDepth = 0
  var keyStart = -1
  var inStr = false
  var strCh = ""
  var i
  for (i = 0; i < args.length; i++) {
    var ch = args.charAt(i)
    var prev = i > 0 ? args.charAt(i - 1) : ""
    if (inStr) {
      if (ch === strCh && prev !== "\\") inStr = false
      continue
    }
    if (charIsQuote(ch)) {
      inStr = true
      strCh = ch
      continue
    }
    if (ch === "{") {
      braceDepth++
      if (braceDepth === 1) keyStart = i + 1
      continue
    }
    if (ch === "}") {
      braceDepth--
      keyStart = -1
      continue
    }
    if (braceDepth === 1 && (ch === "," || ch === "[")) {
      keyStart = i + 1
      continue
    }
    if (braceDepth === 1 && (ch === ":" || ch === "=")) {
      keyStart = -1
    }
  }
  if (braceDepth !== 1 || keyStart < 0) return null
  var raw = args.substring(keyStart)
  var tokenMatch = raw.match(/^\s*"?'?`?([A-Za-z0-9_]*)$/)
  if (!tokenMatch) return null
  return {
    kind: "cb-options",
    group: group,
    prefix: tokenMatch[1],
    quoted: /^\s*["'`]/.test(raw)
  }
}

function prefixForPosition(model, position) {
  var start = position.lineNumber - 40
  if (start < 1) start = 1
  var parts = []
  var i
  for (i = start; i < position.lineNumber; i++) {
    parts.push(model.getLineContent(i))
  }
  parts.push(model.getLineContent(position.lineNumber).substring(0, position.column - 1))
  return parts.join("\n")
}

function modelKey(model) {
  if (!model || !model.uri) return ""
  return model.uri.toString()
}

export function setScriptSdkDialect(model, dialect) {
  var key = modelKey(model)
  if (!key) return
  if (dialect) {
    modelDialects[key] = dialect
  } else {
    delete modelDialects[key]
  }
}

export function clearScriptSdkDialect(model) {
  var key = modelKey(model)
  if (!key) return
  delete modelDialects[key]
}

export function getScriptSdkDialect(model) {
  var key = modelKey(model)
  if (!key) return null
  return modelDialects[key] || null
}

export function inferScriptSdkScope(linePrefix) {
  var text = String(linePrefix || "")
  var optionsScope = inferCbOptionsScope(text)
  if (optionsScope) return optionsScope
  var cbMember = text.match(/\bcb\s*\.\s*([A-Za-z0-9_]*)$/)
  if (cbMember) {
    return { kind: "cb-member", prefix: cbMember[1] }
  }
  var loggerMember = text.match(/\blogger\s*\.\s*([A-Za-z0-9_]*)$/)
  if (loggerMember) {
    return { kind: "logger-member", prefix: loggerMember[1] }
  }
  var ident = text.match(/(?:^|[^A-Za-z0-9_$])([A-Za-z_][A-Za-z0-9_]*)$/)
  if (ident) {
    return { kind: "global", prefix: ident[1] }
  }
  return { kind: "none" }
}

export function buildScriptSdkSuggestions(monaco, scope, range, dialect) {
  if (!scope || scope.kind === "none" || !dialect) return []
  var kindMethod = monaco.languages.CompletionItemKind.Method
  var kindProperty = monaco.languages.CompletionItemKind.Property
  var kindVariable = monaco.languages.CompletionItemKind.Variable
  var kindField = monaco.languages.CompletionItemKind.Field || kindProperty
  var snippetRule = monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet
  var prefix = scope.prefix ? String(scope.prefix).toLowerCase() : ""
  var out = []
  var i
  if (scope.kind === "cb-options") {
    var keys = optionKeyEntries(scope.group, dialect)
    for (i = 0; i < keys.length; i++) {
      var key = keys[i]
      if (prefix && key.label.toLowerCase().indexOf(prefix) !== 0) continue
      out.push({
        label: key.label,
        kind: kindField,
        insertText: optionInsertText(dialect, key.label, !!scope.quoted),
        insertTextRules: snippetRule,
        detail: key.detail,
        sortText: (key.primary ? "0_" : key.alias ? "2_" : "1_") + key.label,
        range: range
      })
    }
    return out
  }
  var list
  if (scope.kind === "cb-member") {
    list = cbMembersForDialect(dialect)
  } else if (scope.kind === "logger-member") {
    list = loggerMembersForDialect(dialect)
  } else if (scope.kind === "global") {
    list = globalsForDialect(dialect)
  } else {
    return []
  }
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    if (prefix && item.label.toLowerCase().indexOf(prefix) !== 0) continue
    var isProp = !!item.property
    var isGlobal = scope.kind === "global"
    out.push({
      label: item.label,
      kind: isGlobal ? kindVariable : isProp ? kindProperty : kindMethod,
      insertText: item.insertText,
      insertTextRules: isProp || isGlobal ? undefined : snippetRule,
      detail: item.detail,
      range: range
    })
  }
  return out
}

export function registerScriptSdkCompletions(monaco) {
  if (providerRegistered || !monaco) return
  providerRegistered = true
  console.debug("[script-sdk] completion provider registered")
  var provide = function (model, position) {
    var dialect = getScriptSdkDialect(model)
    var prefix = prefixForPosition(model, position)
    var scope = inferScriptSdkScope(prefix)
    console.debug("[script-sdk] looking up completions", {
      dialect: dialect || "(none)",
      language: model.getModeId ? model.getModeId() : "",
      prefix: prefix,
      scope: scope.kind,
      token: scope.prefix || "",
      group: scope.group || ""
    })
    if (!dialect) {
      console.debug("[script-sdk] skip — no FaaS dialect on this editor (Expressive5/Agentic/JSON)")
      return { suggestions: [] }
    }
    if (scope.kind === "none") {
      console.debug("[script-sdk] skip — prefix is not cb. / logger. / a global / options")
      return { suggestions: [] }
    }
    var word = model.getWordUntilPosition(position)
    var range = {
      startLineNumber: position.lineNumber,
      endLineNumber: position.lineNumber,
      startColumn: word.startColumn,
      endColumn: word.endColumn
    }
    var suggestions = buildScriptSdkSuggestions(monaco, scope, range, dialect)
    console.debug("[script-sdk] " + suggestions.length + " suggestion(s) for " + scope.kind)
    return { suggestions: suggestions }
  }
  var i
  for (i = 0; i < SDK_LANGUAGES.length; i++) {
    monaco.languages.registerCompletionItemProvider(SDK_LANGUAGES[i], {
      triggerCharacters: [".", "_", "{", ",", "\"", "'", "["],
      provideCompletionItems: provide
    })
  }
}
